var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBroadbandHome(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 41,
    height: 33,
    viewBox: "0 0 41 33",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    stroke: "#DD353F",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 8.54c10.585-10.054 27.748-10.054 38.333 0M5 13.568c7.824-7.82 20.51-7.82 28.333 0M10 18.595c5.063-5.586 13.27-5.586 18.333 0M22.5 25.297a3.341 3.341 0 0 1-3.333 3.352 3.341 3.341 0 0 1-3.334-3.352 3.341 3.341 0 0 1 3.334-3.351c1.841 0 3.333 1.5 3.333 3.351zM40 24.878l-7.083-7.121-7.084 7.121h1.771V32h3.542v-5.341h3.541V32h3.542v-7.122z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBroadbandHome);
export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSI0MSIgaGVpZ2h0PSIzMyIgdmlld0JveD0iMCAwIDQxIDMzIj4KICAgIDxnIGZpbGw9Im5vbmUiIGZpbGwtcnVsZT0iZXZlbm9kZCIgc3Ryb2tlPSIjREQzNTNGIiBzdHJva2UtbGluZWNhcD0icm91bmQiIHN0cm9rZS1saW5lam9pbj0icm91bmQiPgogICAgICAgIDxwYXRoIGQ9Ik0wIDguNTRjMTAuNTg1LTEwLjA1NCAyNy43NDgtMTAuMDU0IDM4LjMzMyAwTTUgMTMuNTY4YzcuODI0LTcuODIgMjAuNTEtNy44MiAyOC4zMzMgME0xMCAxOC41OTVjNS4wNjMtNS41ODYgMTMuMjctNS41ODYgMTguMzMzIDBNMjIuNSAyNS4yOTdhMy4zNDEgMy4zNDEgMCAwIDEtMy4zMzMgMy4zNTIgMy4zNDEgMy4zNDEgMCAwIDEtMy4zMzQtMy4zNTIgMy4zNDEgMy4zNDEgMCAwIDEgMy4zMzQtMy4zNTFjMS44NDEgMCAzLjMzMyAxLjUgMy4zMzMgMy4zNTF6TTQwIDI0Ljg3OGwtNy4wODMtNy4xMjEtNy4wODQgNy4xMjFoMS43NzFWMzJoMy41NDJ2LTUuMzQxaDMuNTQxVjMyaDMuNTQydi03LjEyMnoiLz4KICAgIDwvZz4KPC9zdmc+Cg==";
export { ForwardRef as ReactComponent };